import React from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonCol, IonContent, IonGrid, IonRow, IonText, IonButton, IonCard } from '@ionic/react';
import Header from './admin-header';


const AdminCustomer = () => {


  return (
    <React.Fragment>
      <IonPage>
      <Header/>
      <IonContent>
      <IonHeader >
        <IonToolbar>
          <IonTitle>Customers/Members Management</IonTitle>
        </IonToolbar>
      </IonHeader>
      
      </IonContent>
      </IonPage> 
    
    </React.Fragment>
  );
};

export default AdminCustomer;
